import { findRecursive } from '@/mm/utils.js'

export function washData_productImgText(walkedNode) {
  const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_1', 'list')
  if (ProNode) {
    if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
      ProNode.actions[0].config['文字设计'].unshift('self_textInput')
    }
    if (!ProNode.actions.find((item) => item === 'translate')) {
      ProNode.actions.push('translate')
    }
  }
}
